import { Component } from '@angular/core';

@Component({
    selector: 'app-failed',
    template: `<p>Login failed. Please try again.</p>`,
    styleUrls: [],
    standalone: true
})
export class FailedComponent {}
